"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const datasetContext_1 = __importDefault(require("../../context/dataset/datasetContext"));
const helper_1 = require("../../utils/helper");
const chartContext_1 = __importDefault(require("../../context/chart/chartContext"));
const Dropdown_1 = require("../../components/Dropdown");
const GeoChart_1 = __importDefault(require("../../components/GeoChart"));
const Charts_1 = __importDefault(require("../../components/Charts"));
const Page_1 = __importDefault(require("../../components/Page"));
const Card_1 = __importDefault(require("../../components/Card"));
const jsonpath_1 = __importDefault(require("jsonpath"));
const axios_1 = __importDefault(require("axios"));
require("./Dataset.sass");
const chartTypes = ["bar", "line", "doughnut", "pie", "radar", "map"];
const options = {
    plugins: {
        legend: {
            display: false,
        },
        title: {
            display: true,
            text: "",
            padding: {
                top: 10,
                bottom: 30,
            },
        },
    },
};
const optionsCompare = {
    plugins: {
        legend: {
            display: true,
        },
        title: {
            display: true,
            text: "",
            padding: {
                top: 10,
                bottom: 30,
            },
        },
    },
};
const Datasets = () => {
    /** use ChartContext and DatasetContext */
    const { jsonDataByCategory, jsonDataByIdList, getJsonDataByCategory, getJsonDataByIdList, removeDatasetData } = (0, react_1.useContext)(datasetContext_1.default);
    const { chartTitle, chartLabels, chartDataList, removeChartsData } = (0, react_1.useContext)(chartContext_1.default);
    const selectTableEl = (0, react_1.useRef)(null);
    const selectCategoryEl = (0, react_1.useRef)(null);
    const datasetWrapper = (0, react_1.useRef)(null);
    const [chart, setChart] = (0, react_1.useState)("bar");
    const [compareMode, setCompareMode] = (0, react_1.useState)(false);
    const [compareModeEnable, setCompareModeEnable] = (0, react_1.useState)(false);
    const [chartOptions, setChartOptions] = (0, react_1.useState)(options);
    const [selectedDataset, setSelectedDataset] = (0, react_1.useState)("");
    const [selectedTable, setSelectedTable] = (0, react_1.useState)(null);
    const [downloadButtonUrl, setDownloadButtonUrl] = (0, react_1.useState)("");
    const [dataCategory, setDataCategory] = (0, react_1.useState)("");
    const [chartDataView, setChartDataView] = (0, react_1.useState)({
        labels: [],
        datasets: [],
    });
    const resetAllState = () => {
        setChart("bar");
        setDataCategory("");
        setCompareMode(false);
        setSelectedDataset("");
        setDownloadButtonUrl("");
        setSelectedTable(null);
        setCompareModeEnable(false);
        setChartDataView({
            labels: [],
            datasets: [],
        });
    };
    const setCategory = (e) => {
        e.preventDefault();
        let categoryI = e.currentTarget.dataset.category;
        setDataCategory(categoryI);
        getJsonDataByCategory(categoryI);
    };
    const setChartData = () => {
        setChart("bar");
        setCompareMode(false);
        const selectElement = selectTableEl.current;
        if (selectElement != null) {
            setSelectedDataset("");
            const optionId = selectElement[selectElement === null || selectElement === void 0 ? void 0 : selectElement.selectedIndex].getAttribute("data-id");
            axios_1.default.get("api/download-file/" + optionId).then((res) => {
                setDownloadButtonUrl(res.data);
            });
            let idList = [];
            jsonDataByCategory.forEach((item) => {
                if (item.title === (selectElement === null || selectElement === void 0 ? void 0 : selectElement.value)) {
                    idList.push(item.id);
                }
            });
            getJsonDataByIdList(idList);
            removeChartsData();
            setChartDataView({
                labels: [],
                datasets: [],
            });
            setSelectedTable(optionId != null ? parseInt(optionId) : null);
        }
    };
    (0, react_1.useEffect)(() => {
        if (jsonDataByIdList.length > 1) {
            setCompareModeEnable(true);
        }
        else {
            setCompareModeEnable(false);
        }
    }, [jsonDataByIdList]);
    (0, react_1.useLayoutEffect)(() => {
        setChartData();
    }, [selectedTable]);
    const setDropdownData = () => {
        const selectCategoryElement = selectCategoryEl.current;
        if (selectCategoryElement != null) {
            setChartDataView({
                labels: [],
                datasets: [],
            });
            setSelectedDataset(selectCategoryElement[selectCategoryElement.selectedIndex].value);
        }
    };
    (0, react_1.useLayoutEffect)(() => {
        setDropdownData();
    }, [selectedDataset]);
    (0, react_1.useEffect)(() => {
        resetAllState();
        removeChartsData();
        removeDatasetData();
        return () => {
            resetAllState();
            removeChartsData();
            removeDatasetData();
        };
    }, []);
    (0, react_1.useEffect)(() => {
        if (chartDataList.length > 0) {
            let yearArray = chartDataList.map((el) => el.year.toString());
            let chartDataUpdate;
            let datasetlist = [];
            for (let i = 0; i < chartLabels.length; i++) {
                let dataArray = chartDataList.map((el) => el.data[i]);
                datasetlist.push({
                    id: i,
                    label: chartLabels[i],
                    backgroundColor: helper_1.colors,
                    borderColor: helper_1.colors,
                    data: dataArray,
                });
            }
            if (compareMode) {
                chartDataUpdate = {
                    labels: yearArray,
                    datasets: datasetlist,
                };
            }
            else {
                chartDataUpdate = {
                    labels: chartLabels,
                    datasets: [
                        {
                            id: 1,
                            label: chartDataList[0].year.toString(),
                            backgroundColor: helper_1.colors,
                            data: chartDataList[0].data,
                        },
                    ],
                };
            }
            setChartDataView(chartDataUpdate);
        }
    }, [chartDataList, chartLabels, compareMode, dataCategory]);
    const handleClick = (e) => {
        e.preventDefault();
        if (e.target instanceof Element) {
            const button = e.target.closest("button");
            if (button) {
                chartDataView.datasets.forEach((dataset) => {
                    const length = dataset.data.length;
                    const colorArray = helper_1.colors;
                    const colorArrayBorder = [];
                    if (compareMode) {
                        for (let i = 0; i < length; i++) {
                            let color = (0, helper_1.generateRandomColor)();
                            colorArray.push(color + "77");
                            colorArrayBorder.push(color);
                        }
                        dataset.backgroundColor = colorArray;
                        dataset.borderColor = colorArrayBorder;
                    }
                    if (!compareMode) {
                        dataset.backgroundColor = colorArray;
                        dataset.borderColor = colorArrayBorder;
                    }
                    switch (button.dataset.name) {
                        case "line":
                            const color = (0, helper_1.generateRandomColor)();
                            dataset.backgroundColor = color + "77";
                            dataset.borderColor = color;
                            break;
                        case "bar":
                            dataset.backgroundColor = colorArray;
                            break;
                        case "doughnut":
                        case "pie":
                            dataset.backgroundColor = colorArray;
                            dataset.borderColor = "#fff";
                            break;
                        case "radar":
                            dataset.backgroundColor = colorArray;
                            break;
                        case "map":
                            break;
                        default:
                            break;
                    }
                });
                button.dataset.name ? setChart(button.dataset.name) : setChart("line");
            }
        }
    };
    const categoryCards = [
        { category: "HEALTH", title: "Santé et Nutrition" },
        { category: "EDUCAT", title: "Education" },
        {
            category: "CHILDP",
            title: "Protection de l'enfant",
        },
        {
            category: "SOCIAL",
            title: "Politique sociale",
        },
        {
            category: "ENVIRO",
            title: "Eau, assainissement et hygiène",
        },
        {
            category: "CIVILR",
            title: "Participation et droits civils",
        },
    ];
    const images = [
        { category: "HEALTH", path: "/icons/health.svg", bgColor: "#006838", color: "#ffffff" },
        { category: "EDUCAT", path: "/icons/education.svg", bgColor: "#BD202E", color: "#ffffff" },
        { category: "CHILDP", path: "/icons/childprotection.svg", bgColor: "#F6921E", color: "#ffffff" },
        { category: "SOCIAL", path: "/icons/social.svg", bgColor: "#754C28", color: "#ffffff" },
        { category: "ENVIRO", path: "/icons/environment.svg", bgColor: "#1B75BB", color: "#ffffff" },
        { category: "CIVILR", path: "/icons/civilrights.svg", bgColor: "#37B34A", color: "#ffffff" },
    ];
    if (dataCategory == "") {
        return (react_1.default.createElement(Page_1.default, { currentLink: "datasets", disableFooter: true },
            react_1.default.createElement("section", { className: "main-content-section h-[calc(100vh-5rem)]" },
                react_1.default.createElement("div", { className: "cardContainer h-full" }, categoryCards.map((e, index) => {
                    return (react_1.default.createElement(Card_1.default, { key: index, dataAttribute: e.category, title: e.title, description: "", onClick: setCategory, image: images[index] }));
                })))));
    }
    else {
        return (react_1.default.createElement(Page_1.default, { currentLink: "datasets" },
            react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("section", { className: "m-auto flex w-full max-w-screen-xl flex-col content-center" },
                    react_1.default.createElement("aside", { className: "chartType-container h-48 w-full md:h-24" },
                        react_1.default.createElement("ul", { className: "list flex-wrap md:flex-nowrap" }, chartTypes.map((chartType, index) => {
                            const comp_active = !compareMode && chartType === "line";
                            const comp_inactive = compareMode && chartType !== "line";
                            const inactiveClasses = "grayscale pointer-events-none opacity-50";
                            return (react_1.default.createElement("button", { className: `chartType-item
                      ${comp_active ? inactiveClasses : ""}
                      ${comp_inactive ? inactiveClasses : ""}`, key: index, onClick: handleClick, "data-name": chartType },
                                react_1.default.createElement("img", { src: `pictures/${chartType}.svg`, alt: chartType })));
                        }))),
                    react_1.default.createElement("div", { className: "visualization" },
                        react_1.default.createElement("div", { className: "w-full md:w-[60%]" },
                            react_1.default.createElement("div", { className: "flex justify-between bg-neutral-300" },
                                react_1.default.createElement("button", { className: "m-4 flex h-12 w-12 items-center justify-center rounded-full bg-white", onClick: () => {
                                        resetAllState();
                                        removeChartsData();
                                        removeDatasetData();
                                        window.scrollTo(0, 0);
                                    } },
                                    react_1.default.createElement("svg", { className: "h-8 w-8", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 256 512" },
                                        react_1.default.createElement("path", { d: "M31.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L127.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L201.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34z" }))),
                                downloadButtonUrl !== "" && (react_1.default.createElement("a", { className: "flex flex-col content-center items-center", href: downloadButtonUrl, download: "excel.xlsx" },
                                    react_1.default.createElement("img", { className: "m-4 h-12", src: "pictures/excel-logo.svg", alt: "Download Excel" }))),
                                react_1.default.createElement("div", { className: "flex flex-col content-center items-center", style: {
                                        backgroundColor: images[images.findIndex((image) => image.category == dataCategory)].bgColor,
                                    } },
                                    react_1.default.createElement("div", { className: "m-4 w-32 h-12 maskedSVG", style: {
                                            backgroundColor: images[images.findIndex((image) => image.category == dataCategory)].color,
                                            maskImage: `url(${images[images.findIndex((image) => image.category == dataCategory)].path})`,
                                            WebkitMaskImage: `url(${images[images.findIndex((image) => image.category == dataCategory)].path})`,
                                        } }))),
                            react_1.default.createElement("div", { className: "chart-container-datasets" }, chart == "map" ? (react_1.default.createElement(GeoChart_1.default, { imported_Data: chartDataView, selectedDataset: selectedDataset, selectedTable: selectedTable })) : (react_1.default.createElement(Charts_1.default, { chartType: chart, data: chartDataView, chartTitle: chartTitle, options: chartOptions })))),
                        react_1.default.createElement("section", { className: "list-of-data" },
                            react_1.default.createElement("button", { className: compareMode ? "toggle-comparemode comparemode-active" : "toggle-comparemode", value: compareMode.toString(), onClick: () => {
                                    compareMode ? setChart("bar") : setChart("line");
                                    compareMode ? setChartOptions(options) : setChartOptions(optionsCompare);
                                    setCompareMode(!compareMode);
                                }, disabled: !compareModeEnable }, "Distribution temporelle"),
                            react_1.default.createElement("div", { className: "table-selection-container" },
                                react_1.default.createElement("select", { className: "table-selection", onChange: (e) => {
                                        const optionId = e.target[e.target.selectedIndex].getAttribute("data-id");
                                        let optionIdNumber = 0;
                                        if (optionId != null)
                                            optionIdNumber = parseInt(optionId);
                                        if (selectedTable == null) {
                                            setSelectedTable(optionIdNumber);
                                        }
                                        else {
                                            setSelectedTable(null);
                                        }
                                    }, defaultValue: "", required: true, ref: selectTableEl },
                                    react_1.default.createElement("option", { hidden: true, disabled: true, value: "" }, "-- s\u00E9lectionner un tableau \u00E0 afficher --"),
                                    jsonDataByCategory &&
                                        jsonDataByCategory.map((item, index) => {
                                            return (react_1.default.createElement("option", { key: index, value: item.title, "data-id": item.id, "data-year": item.year }, item.title + " " + item.year));
                                        })),
                                selectedTable != null && (react_1.default.createElement("select", { className: "table-selection", onChange: (e) => {
                                        if (selectedDataset === "") {
                                            setSelectedDataset(e.target[e.target.selectedIndex].value);
                                        }
                                        else {
                                            setSelectedDataset("");
                                        }
                                    }, defaultValue: "", required: true, ref: selectCategoryEl },
                                    react_1.default.createElement("option", { hidden: true, disabled: true, value: "" }, "-- s\u00E9lectionner une cat\u00E9gorie \u00E0 afficher --"),
                                    jsonDataByIdList[jsonDataByIdList.findIndex((i) => {
                                        return i.id === selectedTable;
                                    })] &&
                                        Object.keys(JSON.parse(jsonDataByIdList[jsonDataByIdList.findIndex((i) => {
                                            return i.id === selectedTable;
                                        })].json_data).tables).map((item, index) => {
                                            return (react_1.default.createElement("option", { key: index, value: item }, item));
                                        })))),
                            react_1.default.createElement("div", { className: "available-data", ref: datasetWrapper }, selectedTable != null && selectedDataset !== "" && selectedDataset != null
                                ? (0, Dropdown_1.createDropDown)(datasetWrapper, selectedDataset, jsonpath_1.default.query(JSON.parse(jsonDataByIdList[jsonDataByIdList.findIndex((i) => {
                                    return i.id === selectedTable;
                                })].json_data), `$..["${selectedDataset}"]`)[0])
                                : undefined)))))));
    }
};
exports.default = Datasets;
